import React, { useContext } from 'react';

import Text from '@amzn/meridian/text';

import { isNil } from 'lodash';
import { Link } from 'react-router-dom';
import { LINK_COLOR } from 'src/constants/agGrid';
import { AppContext } from 'src/contexts/appContext';

export const EntityLink: React.FC<{ name: string }> = (props) => {
    const { entities } = useContext(AppContext);

    const entity = entities?.find((e) => e.entityName === props.name);

    if (!isNil(entity)) {
        return (
            <Link to={`/vendors/${entity.entityId}`} style={{ color: LINK_COLOR, textDecoration: 'none' }}>
                {props.name}
            </Link>
        );
    } else {
        return <Text>{props.name}</Text>;
    }
};
